import { BudgetCost } from './budget-cost.model';

export class DisplayColumnRow {
  rowId: number;
  displayColumns: string[];
  data: BudgetCost[];
}